import { render, staticRenderFns } from "./Refusal.vue?vue&type=template&id=8907f4aa&scoped=true"
import script from "./Refusal.vue?vue&type=script&lang=js"
export * from "./Refusal.vue?vue&type=script&lang=js"
import style0 from "./Refusal.vue?vue&type=style&index=0&id=8907f4aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8907f4aa",
  null
  
)

export default component.exports